/*=========================================================================================
  File Name: themeConfig.js
  Description: Theme configuration
  ----------------------------------------------------------------------------------------
  Item Name: Modern Admin - Clean Bootstrap 4 Dashboard HTML Template
  Author: Pixinvent
  Author URL: hhttp://www.themeforest.net/user/pixinvent
==========================================================================================*/
import {getValueCookie} from "@/utils/cookie";



// MAIN COLORS - VUESAX THEME COLORS
import Vue from 'vue';
import Vuesax from 'vuesax';
import AuthModule from "./src/store/AuthModule";

AuthModule.init();
let myColor = AuthModule.personal_color;
//console.log("Mycolor : "+myColor !== '' ? myColor : '#891A2B')
let colors = {
    primary: '#891A2B',
    success: '#28C76F',
    danger: '#EA5455',
    warning: '#FF9F43',
    dark: '#1E1E1E',
    personal_color: myColor !== '' ? myColor : '#891A2B',
};

Vue.use(Vuesax, { theme: { colors } });

// CONFIGS
const themeConfig = {
    theme: 'light', // options[String]: 'light'(default), 'dark', 'semi-dark'
    sidebarCollapsed: false, // options[Boolean]: true, false(default)
    navbarColor: '#fff', // options[String]: HEX color / rgb / rgba / Valid HTML Color name - (default: #fff)
    navbarType: 'floating', // options[String]: floating(default) / static / sticky / hidden
    footerType: 'static', // options[String]: static(default) / sticky / hidden
    routerTransition: 'tugudu-fade', // options[String]: zoom-fade / slide-fade / fade-bottom / fade / zoom-out / none(default)
    disableCustomizer: false, // options[Boolean]: true, false(default)
    hideScrollToTop: false, // options[Boolean]: true, false(default)
    disableThemeTour: false, // options[Boolean]: true, false(default)
    // NOTE: themeTour will be disabled in screens < 1200. Please refer docs for more info.
};

export default themeConfig;